import brandit_rails from '../../../../api/brandit_rails'
import {
  setPortalsStatusAction,
  setPortalsErrorsAction,
  setPortalsTaskAction,
  setPortalsDataAction,
  setPortalOptionsAction,
  setPortalsAddAction,
  setPortalsUpdateAction,
  setPortalsDeleteAction
} from './portals.actions'

export const fetchAllPortals =
  (options = null) =>
  async dispatch => {
    try {
      dispatch(setPortalsStatusAction('loading'))
      dispatch(setPortalsTaskAction('fetchAll'))

      const { data } = await brandit_rails.request({
        url: '/portals',
        method: 'GET',
        params: options
      })

      dispatch(setPortalsDataAction(data))
      dispatch(setPortalsStatusAction('succeeded'))
    } catch (err) {
      dispatch(setPortalsErrorsAction(err.response.data))
      dispatch(setPortalsStatusAction('failed'))
    } finally {
      dispatch(setPortalsTaskAction(null))
    }
  }

export const fetchOnePortal = id => async dispatch => {
  try {
    dispatch(setPortalsStatusAction('loading'))
    dispatch(setPortalsTaskAction('fetchOne'))

    const { data } = await brandit_rails.request({
      url: `/portals/${id}`,
      method: 'GET'
    })

    dispatch(setPortalsAddAction(data))
    dispatch(setPortalsStatusAction('succeeded'))
  } catch (err) {
    dispatch(setPortalsErrorsAction(err.response.data))
    dispatch(setPortalsStatusAction('failed'))
  } finally {
    dispatch(setPortalsTaskAction(null))
  }
}

export const updatePortal = portal => async dispatch => {
  try {
    dispatch(setPortalsStatusAction('loading'))
    dispatch(setPortalsTaskAction('update'))

    const { data } = await brandit_rails.request({
      url: `/portals/${portal.id}`,
      method: 'PUT',
      data: portal
    })

    dispatch(setPortalsUpdateAction(data))
    dispatch(setPortalsStatusAction('succeeded'))
  } catch (err) {
    dispatch(setPortalsErrorsAction(err.response.data))
    dispatch(setPortalsStatusAction('failed'))
  } finally {
    dispatch(setPortalsTaskAction(null))
  }
}

export const deletePortal = id => async dispatch => {
  try {
    dispatch(setPortalsStatusAction('loading'))
    dispatch(setPortalsTaskAction('delete'))

    const { data } = await brandit_rails.request({
      url: `/portals/${id}`,
      method: 'DELETE'
    })

    dispatch(setPortalsDeleteAction(data))
    dispatch(setPortalsStatusAction('succeeded'))
  } catch (err) {
    dispatch(setPortalsErrorsAction(err.response.data))
    dispatch(setPortalsStatusAction('failed'))
  } finally {
    dispatch(setPortalsTaskAction(null))
  }
}

/**
 * Fetch lightweight portal options for dropdowns
 * @param {Object} options - Query parameters
 * @param {number} [options.client_id] - Filter portals by client ID
 * @param {number} [options.product_id] - Filter portals that contain the specified product
 * @param {string} [options.search] - Search portals by name or description
 */
export const fetchPortalOptions =
  (options = {}) =>
  async dispatch => {
    try {
      dispatch(setPortalsStatusAction('loading'))

      const { data } = await brandit_rails.request({
        url: '/portal_options',
        method: 'GET',
        params: options
      })

      dispatch(setPortalOptionsAction(data))
      dispatch(setPortalsStatusAction('succeeded'))
      return data
    } catch (err) {
      dispatch(setPortalsErrorsAction(err.response?.data || err.message))
      dispatch(setPortalsStatusAction('failed'))
      throw err
    }
  }
